// Services/ExpertService.js
import api from "Common/Client/Interceptor";
import { toArray } from "Common/utils/list";

// Get all experts
export const getExperts = async () => {
  try {
    const response = await api.get("/indv/Experts/expert-services/experts");
    return toArray(response.data);
  } catch (error) {
    console.error("Error fetching experts:", error);
    throw error;
  }
};



// Get all expert services
export const getExpertServices = async () => {
  try {
    const response = await api.get("/indv/ExpertServices/Admin/Get-List");
    return response.data;
  } catch (error) {
    console.error("Error fetching expert services:", error);
    throw error;
  }
};




export const getServiceById = async (serviceId) => {
  try {
    const response = await api.get(`/indv/ExpertServices/get-by-id/${serviceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching service details:", error);
    throw error;
  }
};

// Create a new expert service
export const createExpertService = async (serviceData) => {
  try {
    // The API expects hours, not durationMinutes
    const apiData = {
      expertId: serviceData.expertId,
      title: serviceData.title,
      description: serviceData.description,
      defaultPricing: {
        price: serviceData.defaultPricing.price,
        hours: serviceData.defaultPricing.hours, // Already in hours format
        notes: serviceData.defaultPricing.notes
      }
    };
    
    console.log("Creating service with data:", apiData);
    const response = await api.post("/indv/ExpertServices/create", apiData);
    return response.data;
  } catch (error) {
    console.error("Error creating expert service:", error);
    throw error;
  }
};

// Update function 
export const updateExpertService = async (serviceId, serviceData) => {
  try {
    
    const requestData = {
      expertServiceId: parseInt(serviceId),
      title: serviceData.title,
      description: serviceData.description
    };
    
    const response = await api.put(`/indv/ExpertServices/update`, requestData);
    return response.data;   
  } catch (error) {
    console.error("Error updating expert service:", error);
    throw error;
  }
};
